import React, { useState, useEffect, useRef, Fragment } from "react";
import { Link } from "react-router-dom";

import { Container, Row, Col, Button, Card } from "reactstrap";

// core components
import GetStarted from "components/Sections/GetStarted";
import AppNavbar from "components/Navbars/AppNavbar";
import SimpleFooter from "components/Footers/SimpleFooter";

export default function Features(props) {

    const mainEl = useRef(null);

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainEl.current.scrollTop = 0;

        document.title = "Club Apps | Born and Bred in San Antonio, Texas"
        document.querySelector('meta[name="description"]').setAttribute("content", "lub Apps brings users a new experience combining a social platform front-end with a versitile members relations backbone resulting in a new way for groups to interact.");
    }, []);

    return (
        <Fragment>
            <AppNavbar white />
            <main ref={mainEl}>
                <section className="section about-us-section">
                    <div className="about-us-background-container"/>
                </section>
                <section className="section bg-secondary">
                    <Container className="pb-5">
                        <Card className="card-profile shadow mt--200">
                            <div className="px-4">
                                <div className="text-center mt-5">
                                    <h1 className="display-2 mb-1">
                                        We are Club Apps
                                    </h1>
                                    <h4 className="font-weight-300 mb-1">
                                        San Antonio, Texas
                                    </h4>
                                    <h6 className="font-weight-600 text-success mb-0">
                                        Established 2020
                                    </h6>
                                </div>
                                <div className="mt-5 pt-5 border-top text-center">
                                    <Row className="justify-content-center">
                                        <Col lg="9">
                                            <h3 className="display-4 mb-2">
                                                A new way to Manage your Membership
                                            </h3>
                                            <p className="mb-0">
                                                After working for several years on private cloud-based software solutions, founder Tres Plummer and advisor Tres Steves noticed an opportunity to change the way clubs and organizations were advancing into the digital age. Allowing users to join and maintain one profile, as opposed to several individual accounts, allows for exceptional advantages to both users and the organizations they associate with, giving rise to the Unified User Experience. This methodology combines a membership relations backbone with a social platform experience resulting in a new way for groups to interact.
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="mt-5 py-5 border-top text-center">
                                    <Row>
                                        <Col md="6">
                                            <h4 className="display-5 mb-2">
                                                What we Do
                                            </h4>
                                            <p className="mb-4 mb-md-0">
                                                Our team strives daily to identify and accomplish the goals of our customers and end-users. We focus primarily on building features that cater to the unique situations membership-based organizations face in the digital world, with an emphasis on security and usability.
                                            </p>
                                        </Col>
                                        <Col md="6">
                                            <h4 className="display-5 mb-2">
                                                Who we Are
                                            </h4>
                                            <p className="mb-0">
                                                A small team located in San Antonio, Texas and remotely around the United States, we are an enthusiastic bunch of start-up junkies (entrepreneurs) excited to bring our ideas to life.
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Card>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-white"
                                points="2560 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <GetStarted />
            </main>
            <SimpleFooter />
        </Fragment>
    );
}
